import { batch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { doRequest } from '@r1-frontend/do-request';
import { getInfoAll } from '@r1-frontend/api-domru/api-profile/v2/info/all';
import { ResponseContactDto } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';
import { parseContacts } from '@r1-frontend/entities/stores/auth/actions/clientInfo';
import { catch401 } from '@r1-frontend/entities/stores/auth/helpers/catch401';
import { TState } from '@r1-frontend/entities/stores/auth/reducer';
import { EStage } from '@r1-frontend/entities/stores/auth/reducer';
import selectProviderId from '@r1-frontend/entities/stores/city/selectors/selectProviderId';

import { getAgreementNumber } from '@r1-frontend/shared/helpers/getAgreementNumber';

import { clientContactsLoading, setClientContacts, setClientInfoStage } from '../actionCreators';

/** @deprecated use frontend/apps/b2c-domru/src/store/actions/auth/getInfoAll.ts **/
export function getClientContacts() {
    return async(dispatch: ThunkDispatch<TState, void, AnyAction>, getState: () => TState) => {
        const state = getState();
        if (!state.auth.isAuth) {
            return;
        }
        if (state.auth.isClientContactsLoading) {
            return;
        }

        const providerId = selectProviderId(state);
        const accessToken = state.auth.accessToken;
        const agreementNumber = getAgreementNumber();
        // актуальные статусы
        dispatch(setClientInfoStage({
            contacts: EStage.loading,
        }));
        const resp = await doRequest.apiProfile<ResponseContactDto>(
            getInfoAll(providerId, accessToken, agreementNumber, ['contacts']),
        );
        if (resp.isSuccess) {
            const { contacts } = resp.payload;
            batch(() => {
                dispatch(setClientContacts(parseContacts(contacts)));
                dispatch(setClientInfoStage({
                    contacts: EStage.loaded,
                }));
            });
        } else if (catch401(resp.error)) {
            return;
        }

        dispatch(clientContactsLoading(false));
    };
}
